import React from "react";
import { Box, Typography, Card, CardContent, CardMedia } from "@mui/material";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import DrPonce from "../images/AboutDrPonce.jpg";

const Container = styled.div``;

const Title = styled.h1`
  text-align: center;
  margin: 0 0 16px 0;
  color: rgb(104 38 85);
  @media (max-width: 700px) {
  }
`;
const MeetDrPonce: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Title>{t("AboutDrPonce.title").toUpperCase()}</Title>

      <Card
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          boxShadow: 4,
        }}
      >
        <CardMedia
          component="img"
          sx={{ width: { xs: "100%", md: 300 }, objectFit: "cover" }}
          image={DrPonce}
          alt="Dr. Ponce"
        />
        <CardContent>
          <Typography variant="h6" gutterBottom>
            {t("AboutDrPonce.subtitle")}
          </Typography>
          <Typography variant="body1" paragraph>
            {t("AboutDrPonce.intro")}
          </Typography>
          <Typography variant="body1" paragraph>
            {t("AboutDrPonce.dream")}
          </Typography>
          <Typography variant="body1" paragraph>
            {t("AboutDrPonce.mission")}
          </Typography>
          <Typography variant="body1" paragraph>
            {t("AboutDrPonce.commitment")}
          </Typography>
          <Typography variant="body1">{t("AboutDrPonce.welcome")}</Typography>
        </CardContent>
      </Card>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          {t("AboutDrPonce.videoTitle")}
        </Typography>
        <Box
          sx={{
            position: "relative",
            paddingBottom: "56.25%",
            height: 0,
            overflow: "hidden",
            borderRadius: 2,
            boxShadow: 3,
            width: "100%",
            display: "flex",
            justifySelf: "center",
          }}
        >
          <iframe
            src="https://www.youtube.com/embed/iHakb7KDvhw?si=FoYpLr5hQpIBG-Is"
            title="Meet Dr. Ponce"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
          ></iframe>
        </Box>
      </Box>
    </Container>
  );
};

export default MeetDrPonce;
